import React from "react"
import HeaderSelect from "../../../components/Headers/HeaderSelect"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../../hooks/enterprise"
import Link from "next/link"
import LayoutSelect from "../../../components/Layouts/LayoutSelect"
import HeaderSelectTop from "../../../components/Headers/HeaderSelectTop"
import { ArrowLeft } from "lucide-react"
import ShopList from "../../../components/Shop/ShopList"
import LayoutLoadingAuthRequired from "../../../components/Layouts/LayoutLoadingAuthRequired"

function Index() {
  const enterpriseId = useMainEnterpriseId()
  const { enterprise, isLoading, isError } = useEnterpriseGetOne(enterpriseId)

  if (isLoading || isError) {
    return (
      <React.Fragment>
        <LayoutLoadingAuthRequired isLoading={isLoading} isError={isError} />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <LayoutSelect title="Выберите магазин">
        <HeaderSelectTop>
          <Link
            href={"/e"}
            className="inline-flex items-center rounded-md border border-border bg-card px-4 py-2 text-sm font-medium text-foreground shadow-xs transition-colors hover:bg-muted focus:ring-2 focus:ring-ring focus:outline-none"
          >
            <ArrowLeft
              className="mr-2 size-4 text-muted-foreground"
              aria-hidden="true"
            />
            <span>Назад к выбору предприятия</span>
          </Link>
        </HeaderSelectTop>

        <HeaderSelect
          name={enterprise?.title}
          title={"Выберите магазин"}
          subTitle={
            "Данный выбор будет сохранён для простоты работы. Вы всегда сможете вернуться к выбору в разделе настроек"
          }
        />

        <ShopList />
      </LayoutSelect>
    </React.Fragment>
  )
}

export default Index
